export class APCreditApplicationTransactionItemParametersDto {
    sourceItemId: number;

    targetItemId: number;
    applyAmount: number;
}
